import * as yup from "yup";

export const VALIDATION_SCHEMA = yup.object({
  rows: yup.array().min(1, "Table data cannot be empty!"),
});
